export default __webpack_public_path__ + "static/media/iconmonstr-facebook-3.4b266d41.svg";